import { Component, ElementRef, Renderer2, ViewContainerRef, OnChanges } from '@angular/core'
import { I18nService } from 'app/_services/i18n.service'
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader'
import { BsDatepickerInlineConfig, BsDaterangepickerInlineDirective, BsLocaleService } from 'ngx-bootstrap/datepicker'

/**
 * Component that extends the ngx-bootstrap daterangepicker inline directive
 * and integrates with the I18nService for language changes.
 */
@Component({
    selector: 'app-bs-daterangepicker-inline',
    template: '',
})
export class AppBsDaterangepickerInlineComponent extends BsDaterangepickerInlineDirective implements OnChanges {
    constructor(
        _config: BsDatepickerInlineConfig,
        _elementRef: ElementRef,
        _renderer: Renderer2,
        _viewContainerRef: ViewContainerRef,
        cis: ComponentLoaderFactory,
        private i18nService: I18nService,
        private bsLocaleService: BsLocaleService
    ) {
        super(_config, _elementRef, _renderer, _viewContainerRef, cis)
        this.i18nService.messages.subscribe(() => {
            this.bsLocaleService.use(this.i18nService.languageId)
            super.ngOnChanges({})
        })
    }
}
